const ITEMS = ["Branding", "Graphic Design", "Web Design", "Marketing", "Print", "Social Media"];
const COLORS = ["bg-staxyellow", "bg-staxmagenta", "bg-staxcyan"];

export const Marquee = ({ dark = false }) => (
  <div
    data-testid="marquee-strip"
    className={`overflow-hidden border-y-4 border-ink py-5 ${dark ? "bg-ink" : "bg-staxyellow"}`}
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className={`font-display uppercase text-4xl sm:text-5xl px-8 ${dark ? "text-white" : "text-ink"}`}>
                {item}
              </span>
              <span className={`h-5 w-5 rounded-full ${COLORS[i % 3]} ${dark ? "" : "mix-blend-multiply"}`} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
